import { pipe, filter, propEq, complement, values } from 'ramda';
import { createSelector } from 'reselect';

import { hasNilValues } from '../../../../helpers/validation.helpers';
import { IRootState } from '../../../../store/root.types';
import { IShippingAddress, IShippingValidation } from '../shipping/shipping.types';

const pathToGiftFlowState = (state: IRootState) => state.recipient.giftFlow;

export const getActiveStatus = pipe(pathToGiftFlowState, state => state.activeStatus);

export const getStatuses = pipe(pathToGiftFlowState, state => state.statuses);

export const getVisibleStatuses = pipe(getStatuses, filter(propEq('isVisible', true)));

export const getTimezone = pipe(pathToGiftFlowState, state => state.timezone);

export const getFromDate = pipe(pathToGiftFlowState, state => state.from);

export const getToDate = pipe(pathToGiftFlowState, state => state.to);

export const getMeetingSlots = pipe(pathToGiftFlowState, state => state.slots);

export const getMeetingNotes = pipe(pathToGiftFlowState, state => state.notes);

export const getProspects = pipe(pathToGiftFlowState, state => state.prospects);

export const getShipping = pipe(pathToGiftFlowState, state => state.shipping);

const checkShipping = pipe(
  (address: Partial<IShippingAddress>) => ({
    address: address.address,
    city: address.city,
    country: address.country,
    state: address.state,
    zipcode: address.zipcode,
    phone: address.phone,
  }),
  values,
  complement(hasNilValues),
);

export const getHasShippingAddress = createSelector(getShipping, (shipping: IShippingValidation | null) =>
  checkShipping(shipping?.address || {}),
);

export const getProduct = pipe(pathToGiftFlowState, state => state.product);

export const getIsDonation = pipe(pathToGiftFlowState, state => state.isDonation);

export const getFlowRecipient = pipe(pathToGiftFlowState, state => state.recipient);

export const getCountryId = pipe(pathToGiftFlowState, state => state.countryId);

export const getIsConfirmedFlow = pipe(pathToGiftFlowState, state => state.isConfirmedFlow);

export const getFlowHashId = pipe(pathToGiftFlowState, state => state.hashId);

export const getIsEmptyGiftFlow = createSelector(
  getFlowHashId,
  getFlowRecipient,
  getCountryId,
  (hashId, recipient, countryId) => hashId === '' || recipient === null || countryId === null,
);

export const getProductId = pipe(getProduct, product => product?.id);
